// src/hooks/useExpenses.tsx — reads from MySQL via API, no IndexedDB
import { useEffect, useState, useCallback } from 'react';
import { apiGetExpenses } from '../services/expenseAPI';

export type Expense = any;

export function useExpenses(limit = 10000) {
  const [items, setItems]   = useState<Expense[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError]   = useState<unknown>(null);

  const load = useCallback(async () => {
    try {
      setLoading(true);
      const all = await apiGetExpenses();
      all.sort((a: any, b: any) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());
      setItems(limit ? all.slice(0, limit) : all);
    } catch (e) {
      setError(e);
    } finally {
      setLoading(false);
    }
  }, [limit]);

  useEffect(() => { load(); }, [load]);

  return { items, loading, error, reload: load };
}
